<template>
  <div :id="id" v-loading="loading" class="vegaContain" element-loading-text="数据统计中..."
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
</template>

<script>
import * as vega from "vega";
import apiAxios from "@/config/apiAxios";
export default {
  name: "infodisc",
  props: {
    id: {
      type: String,
      required: true,
      default: "",
    },
    // width: {
    //     type: String,
    //     default: document.body.clientWidth / 3 - 20 + 'px'
    // },
    height: {
      type: String,
      default: "320px",
    },
  },
  components: {},
  data() {
    return {
      vegaDefaultConfig: {
        $schema: "https://vega.github.io/schema/vega/v5.json",
        description: "A basic stacked bar chart example.",
        width: 500,
        height: 320,
        padding: 0,
        autosize: "fit",
        data: [
          {
            name: "market",
            values: [],
            transform: [
              {
                type: "formula",
                expr: "if(indexof(datum.SECCODE,'0')==0,'深交所主板',null)",
                as: "board",
              },
              {
                type: "formula",
                expr:
                  "if(indexof(datum.SECCODE,'3')==0 && !datum.board,'深交所创业板',datum.board)",
                as: "board",
              },
              {
                type: "formula",
                expr:
                  "if(indexof(datum.SECCODE,'68')==0 && !datum.board,'上交所科创板',datum.board)",
                as: "board",
              },
              {
                type: "formula",
                expr:
                  "if((indexof(datum.SECCODE,'6')==0 || indexof(datum.SECCODE,'9')==0) && !datum.board,'上交所主板',datum.board)",
                as: "board",
              },
              {
                type: "formula",
                expr:
                  "if((indexof(datum.SECCODE,'4')==0 || indexof(datum.SECCODE,'8')==0) && !datum.board,'北交所',datum.board)",
                as: "board",
              },
              {
                type: "formula",
                expr:
                  "if((datum.SECCODE=='200152' || datum.SECCODE=='200468'|| datum.SECCODE=='200512'|| datum.SECCODE=='200706'|| datum.SECCODE=='200992'|| datum.SECCODE=='200054'|| datum.SECCODE=='200771') && !datum.board,'深交所主板',datum.board)",
                as: "board",
              },
              {
                type: "filter",
                expr: "datum.board",
              },
            ],
          },
          {
            name: "market_now",
            source: ["market"],
            transform: [
              {
                type: "filter",
                expr: "datum.F006D",
              },
              {
                type: "formula",
                expr: "0",
                as: "order",
              },
            ],
          },
          {
            name: "board_now",
            source: ["market_now"],
            transform: [
              {
                type: "aggregate",
                fields: ["count"],
                groupby: ["board", "order"],
                ops: ["count"],
                as: ["count"],
              },
            ],
          },

          {
            name: "all_now",
            source: ["board_now"],
            transform: [
              {
                type: "aggregate",
                fields: ["count"],
                groupby: ["order"],
                ops: ["sum"],
                as: ["count"],
              },
              {
                type: "formula",
                expr: "'股票市场'",
                as: "board",
              },
            ],
          },
          {
            name: "board",
            source: ["market"],
            transform: [
              {
                type: "aggregate",
                fields: ["count"],
                groupby: ["board"],
                ops: ["count"],
                as: ["count"],
              },
              {
                type: "formula",
                expr: "1",
                as: "order",
              },
            ],
          },

          {
            name: "all",
            source: ["board"],
            transform: [
              {
                type: "aggregate",
                fields: ["count"],
                groupby: ["order"],
                ops: ["sum"],
                as: ["count"],
              },
              {
                type: "formula",
                expr: "'股票市场'",
                as: "board",
              },
            ],
          },
          {
            name: "market_all_order",
            values: [
              {
                board: "股票市场",
              },

              {
                board: "上交所主板",
              },
              {
                board: "上交所科创板",
              },

              {
                board: "深交所主板",
              },
              {
                board: "深交所创业板",
              },
              {
                board: "北交所",
              },
              {
                "board": "固收市场"
              },

              {
                "board": "上交所债券市场"
              },
              {
                "board": "深交所债券市场"
              },
              {
                "board": "银行间债券市场"
              },

              {
                board: "公募基金市场",
              },
            ],
            transform: [
              {
                type: "formula",
                expr: "1",
                as: "order",
              },
              {
                type: "identifier",
                as: "id",
              },
            ],
          },
          {
            name: "bond",
            values: [
              {
                "board": "银行间债券市场",
                "count": 3984,
                "order": 1
              },
              {
                "board": "上交所债券市场",
                "count": 4050,
                "order": 1
              },
              {
                "board": "深交所债券市场",
                "count": 966,
                "order": 1
              }
            ],
          },
          {
            name: "bond_now",
            values: [
              {
                "board": "银行间债券市场",
                "count": 69,
                "order": 0
              },
              {
                "board": "上交所债券市场",
                "count": 3,
                "order": 0
              },
              {
                "board": "深交所债券市场",
                "count": 0,
                "order": 0
              }
            ],
          },
          {
            name: "fund",
            values: [
              {
                board: "公募基金市场",
                count: 10203,
                order: 1,
              },
            ],
          },
          {
            name: "fund_now",
            values: [
              {
                board: "公募基金市场",
                count: 10163,
                order: 0,
              },
            ],
          },
          {
            name: "market_all_temp",
            source: ["board", "all", "fund", "bond"],
            transform: [
              {
                type: "lookup",
                from: "market_all_order",
                key: "board",
                fields: ["board"],
                values: ["id"],
              },
              {
                type: "identifier",
                as: "id",
              },
            ],
          },
          {
            name: "market_all_now",
            source: ["board_now", "all_now", "fund_now", "bond_now"],
            transform: [
              {
                type: "lookup",
                from: "market_all_temp",
                key: "board",
                fields: ["board"],
                values: ["id", "count"],
                as: ["id", "total"],
              },
            ],
          },
          {
            name: "market_all",
            source: ["market_all_temp"],
            transform: [
              {
                type: "formula",
                expr: "datum.count",
                as: "total",
              },
              {
                type: "lookup",
                from: "market_all_now",
                key: "board",
                fields: ["board"],
                values: ["count"],
                as: ["count_now"],
                default: 0,
              },
              {
                type: "formula",
                expr: "datum.count-datum.count_now",
                as: "count",
              },
            ],
          },
          {
            name: "table",
            source: ["market_all_now", "market_all"],
            transform: [
              {
                type: "stack",
                groupby: ["board"],
                sort: { field: "order" },
                field: "count",
              },
              {
                type: "formula",
                expr: "datum.y0/datum.total*100",
                as: "ny0",
              },
              {
                type: "formula",
                expr: "datum.y1/datum.total*100",
                as: "ny1",
              },
            ],
          },
        ],
        signals: [
          {
            name: "width",
            update: "containerSize()[0]",
            on: [
              {
                events: { source: "window", type: "resize" },
                update: "containerSize()[0]",
              },
            ],
          },
          {
            name: "height",
            update: "containerSize()[1]",
            on: [
              {
                events: { source: "window", type: "resize" },
                update: "containerSize()[1]",
              },
            ],
          },
        ],
        scales: [
          {
            name: "yscale",
            type: "band",
            range: "height",
            domain: { data: "table", field: "board", sort: { op: "sum", field: "id" } },
          },
          {
            name: "xscale",
            type: "linear",
            range: "width",
            nice: true,
            zero: true,
            domain: [0, 100],
          },
          {
            name: "color",
            type: "ordinal",

            range: ["#49f787", "steelblue"],
            domain: { data: "table", field: "order" },
          },
        ],

        axes: [
          { orient: "bottom", scale: "xscale", zindex: 1, labelColor: "#fff" },
          { orient: "left", scale: "yscale", zindex: 1, labelColor: "#fff" },
        ],


        title: {
          color: "#fff",
          subtitleColor: "#fff",
         // text: "2022年资本市场年报信息披露进度",
         text: "2023年资本市场半年报信息披露进度",
          anchor: "middle",
          fontSize: 16,
          frame: "group",
          offset: 4,
        },
        marks: [
          {
            name: "bars",
            type: "rect",
            from: { data: "table" },
            encode: {
              enter: {
                y: { scale: "yscale", field: "board" },
                height: { scale: "yscale", band: 1, offset: -1 },
                x: { scale: "xscale", field: "ny0" },
                x2: { scale: "xscale", field: "ny1" },
                fill: { scale: "color", field: "order" },
              },
              update: {
                y: { scale: "yscale", field: "board" },
                height: { scale: "yscale", band: 1, offset: -1 },
                x: { scale: "xscale", field: "ny0" },
                x2: { scale: "xscale", field: "ny1" },
                fillOpacity: { value: 1 },
              },
              hover: {
                fillOpacity: { value: 0.5 },
              },
            },
          },
          {
            type: "text",
            from: { data: "bars" },
            encode: {
              enter: {
                fill: [{ value: "white" }],
                align: { value: "right" },
                baseline: { value: "middle" },
                text: {
                  signal:
                    "if(datum.datum.order==1,'应披露'+datum.datum.total+'家,已披露'+datum.datum.count_now+'家','')",
                },
              },
              update: {
                x: { field: "x2", offset: -5 },
                y: { field: "y", offset: { field: "height", mult: 0.5 } },
              },
            },
          },
        ],
      },
      vegaView: false,
      loading: true,
      fileList: [
        // {
        //   name: "深交所主板",
        //   fid: "07f1ad83f27c8fcf41fc643140b61040",
        //   tags: ["genesys.2021AR_zb_yb"],
        // },
        {
          name: "深交所主板",
          fid: "032b7e9a3a8b9444f3c0345d3b526c0f",
          tags: ["genesys.2023SAR_zb_yb"],
        },
        {
          name: "上交所主板",
          fid: "67c05d524db9846a22022dccc2c8f54d",
          tags: ["genesys.2021AR_sjszb_yb"],
        },
      ],
    };
  },
  methods: {
    vegaInit(data) {
      let width = document.getElementById(this.id).clientWidth;
      let height = document.getElementById(this.id).clientHeight;
      // let width = document.body.clientWidth/3 -100;
      this.vegaDefaultConfig.width = width;
      this.vegaDefaultConfig.height = height;
      this.vegaDefaultConfig.data[0].values = data;
      let aa = vega.parse(this.vegaDefaultConfig);
      var view = new vega.View(vega.parse(this.vegaDefaultConfig))
        .renderer("svg")
        .initialize("#" + this.id)
        .hover()
        .run();
      let that = this;

      view.addEventListener("click", function (event, item) {
        let datanum = item.datum.datum || item.datum;
        if (datanum.board == "深交所主板" || datanum.board == "上交所主板") {
          that.showTpl(datanum);
        } else {
        }
      });
      view.addEventListener("touchstart", function (event, item) {
        let datanum = item.datum.datum || item.datum;
        if (datanum.board == "深交所主板" || datanum.board == "上交所主板") {
          that.showTpl(datanum);
        } else {
        }
      });
      this.vegaView = view;
      this.loading = false;
    },

    showTpl(item) {
      let tplname = this.fileList.filter((x) => x.name == item.board)[0];
      let params = { tags: tplname.tags };
      let loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      apiAxios.apmSyncPost("api000161", params, {}, (_res) => {
        loading.close();
        if (_res.code == 200) {
          let _data = _res.data;
          let datas_obj = {};

          datas_obj.cat_sys_chapter = {
            extends: {
              resource: {
                path: _data.cat_chapter,
              },
            },
          };
          datas_obj.cat_sys_html = {
            extends: {
              resource: {
                path: _data.cat_html,
              },
            },
          };
          datas_obj.ctx_sys_json = {
            extends: {
              resource: {
                path: _data.ctx_tpl,
              },
            },
          };
          datas_obj.meta_element = {
            extends: {
              resource: {
                path: _data.meta_element,
              },
            },
          };
          let ld = _data.ld;

          // datas_obj.cat_html=_data.cat_html;
          //  datas_obj.ctx_sys_json=_data.ctx_tpl;
          //   datas_obj.meta_element=_data.meta_element;
          // datas_obj.ld=_data.ld;
          let _params = {
            datas_obj: datas_obj,
            type: "tpl",
            readerLabel: "数据热力图",
            dialogtitle: item.board,
            ld: ld,
          };
          this.$EventBus.$emit("opendialogCmdpReader", { _params: _params });
        } else {
          this.$notify({
            type: "warn",
            message: "现在只有深主板一般类模板，其他板块努力开始中......",
          });
        }
      });
    },
  },
  mounted() {
    // let that=this
    // window.addEventListener('resize',function(){
    //     let w= document.getElementById(that.id).clientWidth - 100;
    //     if(that.vegaView){
    //      that.vegaView.resize()
    //     }
    // })
    // this.vegaInit();
  },
};
</script>

<style lang="less" scoped>
.vegaContain {
  padding: 5px;
  // border: solid 1px;
  margin: 10px;
}
</style>
